import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { KeycloakService } from 'keycloak-angular';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private keycloakService: KeycloakService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Check if current page is a public route
    const currentPath = window.location.pathname;
    const isPublicPage = currentPath.includes('/pre-checkin') || 
                         currentPath.includes('/housemaid/reporting');
    
    // If on a public page, don't add auth headers
    if (isPublicPage) {
      console.log('Public page detected, skipping auth header');
      return next.handle(request);
    }

    // For protected pages, check if logged in and add token
    return from(this.keycloakService.isLoggedIn()).pipe(
      mergeMap(isLoggedIn => {
        if (isLoggedIn) {
          return from(this.keycloakService.getToken()).pipe(
            mergeMap(token => {
              if (token) {
                request = request.clone({
                  setHeaders: {
                    Authorization: `Bearer ${token}`
                  }
                });
              }
              return next.handle(request);
            })
          );
        }
        return next.handle(request);
      })
    );
  }
}